// extracted by mini-css-extract-plugin
export default {"modal":"MergeModal_modal__3fEDB","question":"MergeModal_question__novAC","inputForm":"MergeModal_inputForm__346FB","actions":"MergeModal_actions__34UsG"};